import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { color } from 'styled-system';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { theme } from '../../theme';

type LoaderProps = {
  color?: string;
  width?: number;
  height?: number;
  hasBackground?: boolean;
};

const anim1 = keyframes`
  0%   { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;
const anim2 = keyframes`
  0%   { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;

const anim3 = keyframes`
  0%   { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;

const Wrapper = styled.div<StyledSystemProps>`
  ${color};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${theme.zIndex[10]};
  display: flex;
  position: absolute;
  align-items: center;
  pointer-events: none;
  justify-content: center;
`;

const StyledLoader = styled.div`
  display: block;
  height: 50px;
  width: 50px;
  animation: ${anim1} 3s linear infinite;
  & span {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 50px;
    margin: auto;
    height: 50px;
    display: block;
    position: absolute;
    clip: rect(25px, 50px, 50px, 0);
    animation: ${anim2} 1.6s cubic-bezier(0.77, 0, 0.175, 1) infinite;
  }

  & span::before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    width: 50px;
    margin: auto;
    height: 50px;
    display: block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid transparent;
    animation: ${anim3} 1.6s cubic-bezier(0.77, 0, 0.175, 1) infinite;
    border-top: 3px solid ${(props: ThemeInterface) => props.theme.colors.putty};
  }
  & span::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    height: ${(props: LoaderProps) => (props.width ? props.height + 'px' : '50px')};
    width: ${(props: LoaderProps) => (props.width ? props.width + 'px' : '50px')};
    border: 3px solid ${props => props.color || '#b8b19b'};
    border-radius: 50%;
  }

  & span:before,
  span::after {
    box-sizing: border-box;
  }
`;

const FillLoader: React.FC<LoaderProps> = props => {
  return (
    <Wrapper data-testid="fill-loader" bg={props.hasBackground ? 'transparentBlack' : 'transparent'}>
      <StyledLoader {...props}>
        <span />
      </StyledLoader>
    </Wrapper>
  );
};

export default FillLoader;

FillLoader.defaultProps = {
  hasBackground: false,
};



// WEBPACK FOOTER //
// ./src/components/loaders/FillLoader.tsx